import Vue from 'vue'
import Router from 'vue-router'
import { beforeResolve, beforeEach, afterEach } from './middleware'

import agencyRoutes from './routes/agencies'
import aidRoutes from './routes/aids'
import analyticsRoutes from './routes/analytics'
import authRoutes from './routes/auth'
import beneficiaryRoutes from './routes/beneficiaries'
import categoryRoutes from './routes/categories'
import eventsRoutes from './routes/events'
import locationRoutes from './routes/locations'
import sectorRoutes from './routes/sectors'
import stateRoutes from './routes/states'
import userRoutes from './routes/users'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue')
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('@/views/Dashboard/Dashboard.vue'),   
      meta: { requiresAuth: true }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/Profile.vue'),
      meta: { requiresAuth: true }
    },
    {
      path: '/analytics',
      name: 'analytics',
      component: () => import('@/views/Analytics.vue')
    },
    ...agencyRoutes,
    ...aidRoutes,
    ...analyticsRoutes,
    ...authRoutes,
    ...beneficiaryRoutes,
    ...categoryRoutes,
    ...eventsRoutes,
    ...locationRoutes,
    ...sectorRoutes,
    ...stateRoutes,
    ...userRoutes,
    {
      path: '/**',
      component: () => import('@/views/Error/404.vue')
    }
  ]
})

// middleware
router.beforeResolve(beforeResolve)
router.beforeEach(beforeEach)
router.afterEach(afterEach)

export default router
